// extracted by mini-css-extract-plugin
export default {"container":"Section_container__A-ldF","verticalAlign":"Section_verticalAlign__+LBJP","flexContainer":"Section_flexContainer__spoUr"};